export const TAB_META = {
    ADMIN: {
        id: 'admin',
        name: 'Admin',
    },
    ADMIN_REPORT: {
        id: 'admin-report',
        name: 'Admin report',
    },
    GENERAL_SETTINGS: {
        id: 'settings',
        name: 'Generelle innstillinger',
    },
    CANDIDATES: {
        id: 'candidates',
        name: 'Kandidater',
    },
    POSTAL_CODE: {
        id: 'post-number',
        name: 'Postnummer',
    },
    PREVIEW: {
        id: 'preview',
        name: 'Forhåndsvis',
    },
    STAND_ADMIN: {
        id: 'stand-admin',
        name: 'Stand admin',
    },
    REPORT: {
        id: 'contact-report',
        name: 'Rapport',
    },
} as const;
